// Client-side tradeable-quantity math for MY OWN collection view. Mirrors
// the server formula in server/routes/_social.js (TRADEABLE_SUBQUERY) —
// friend-facing lists and trade validation always use the server version.

export const overrideKey = (cardId, variant) => `${cardId}|${variant}`;

// override: { mode: 'exclude' | 'include', offerQty } | undefined
export const getTradeableQty = (quantity, override, threshold) => {
  if (override?.mode === 'exclude') return 0;
  if (override?.mode === 'include') {
    return Math.min(override.offerQty ?? quantity, quantity);
  }
  return Math.max(quantity - threshold, 0);
};

// collection: { cardId: { variant: qty } }, overrides: { `${cardId}|${variant}`: override }
// Returns rows sorted by cardId/variant: { cardId, variant, quantity, tradeableQty, override }
export const computeTradeables = (collection, overrides, threshold) => {
  const rows = [];

  for (const [cardId, variants] of Object.entries(collection)) {
    for (const [variant, quantity] of Object.entries(variants)) {
      if (quantity <= 0) continue;
      const override = overrides[overrideKey(cardId, variant)];
      const tradeableQty = getTradeableQty(quantity, override, threshold);
      if (tradeableQty > 0 || override?.mode === 'exclude') {
        rows.push({ cardId, variant, quantity, tradeableQty, override: override || null });
      }
    }
  }

  return rows.sort((a, b) => a.cardId.localeCompare(b.cardId) || a.variant.localeCompare(b.variant));
};
